import React from "react";
import { Footer } from "../Components/Footer";

const OurTeamMembers = () => {
  return (
    <div>
      <div className="container my-5">
        <div
          className="px-0 mx-0 py-5 col-12"
          data-aos="fade-right"
          data-aos-delay="300"
        >
          <h2
            className="py-2 div-heading"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            Meet Our Associates
          </h2>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div className="col-md-4 d-lg-flex d-none" data-aos="fade-right">
            <img
              className="img-fluid about-us-team-img"
              src="/Images/unnamed.png"
              alt="profile image"
            />
          </div>
          <div className="col-md-8 col-12" data-aos="fade-left">
            <h3 className="text-primary">Dr. Yasmin Majumder</h3>
            <p className="f-22-b text-secondary">DNP, FNP-BC, PMHNP</p>
            <div className="f-18-n custom-text-alignment">
              <p>
                Dr. Yasmin Majumder is a highly skilled nurse practitioner,
                serving as the co-founder and CEO of Unicare Psychiatry (UP)
                PLLC since 2020. Through UP, she delivers comprehensive
                healthcare services in primary care and mental health settings
                to a diverse patient base, catering to individuals of all age
                groups. She offers both in-person and telehealth consultations,
                extending her services even to hospice patients. In addition to
                addressing alcohol and opiate addiction, Dr. Yasmin provides a
                variety of therapies, including hypnotherapy, psychoanalysis,
                and neurofeedback, alongside medication management.
              </p>
            </div>
          </div>
        </div>
        <div className="row col-12 p-0 m-0" data-aos="fade-left">
          <h4 className="mt-3 mt-md-5 row text-secondary div-sub-heading">
            Professional Background
          </h4>
          <div
            data-aos="fade-left"
            className="col-md-6 col-12 order-lg-1 order-2 my-md-5 my-0 p-5"
          >
            <p className="f-18-n custom-text-alignment">
              At UP, Dr. Yasmin has established opportunities for Psychiatric
              Mental Health Nurse Practitioner (PMHNP) students to gain valuable
              clinical experience at minimal costs. The fees collected are
              primarily utilized to maintain a secure HEPPA-compliant
              environment.
            </p>
            <p className="f-18-n custom-text-alignment">
              The mission of UP is centered around empowering new PMHNPs,
              particularly in regions with limited access to psychiatric care,
              such as rural areas. UP extends its services to Wisconsin, New
              York, and Iowa through telehealth, addressing the severe need for
              mental health services in underserved populations.
            </p>
          </div>

          <div
            data-aos="fade-right"
            className="col-md-6 col-12 order-1 order-md-1 p-5"
          >
            <img
              className="img-fluid shadow-plus-border h-75 w-100"
              src="Images/professionalbg.webp"
              alt="picture"
            />
          </div>
        </div>
        <div className="container" data-aos="fade-left">
          <p className="f-18-n custom-text-alignment">
            Unicare Psychiatry is confident in its global expansion, guided by a
            faith-based approach that harmonizes both scientific advancements
            and technological innovations. Dr. Yasmin's proficiency in English
            and Bengali ensures effective communication with a wide array of
            patients. To further enhance cultural sensitivity, UP provides
            interpreters for the Spanish-speaking Hispanic community. Dr.
            Yasmin, a devoted practitioner, holds certifications in psychiatric
            mental health and family practice. She is deeply committed to
            providing high-quality care to underprivileged individuals facing
            health disparities, with a strong emphasis on advocating for
            patients and students within the UC framework.
          </p>
        </div>
        <div className="line pb-3"></div>
        <div className="row overflow-hidden col-12 p-0 m-0">
          {/* <h4 className="mt-md-5 mt-4 row f-22-b text-secondary">
            Academic Background
          </h4> */}
          <h4 className="mt-3 mt-md-5 row text-secondary div-sub-heading">
            Academic Background
          </h4>
          <div
            data-aos="fade-left"
            className="col-md-6 col-12 order-lg-1 order-2 my-md-5 my-0"
          >
            <div className="p-3">
              <span className="d-flex flex-row f-22-n text-primary">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/University.png"
                />
                NORTHERN KENTUCKY
              </span>
              <span className="d-flex my-1 flex-row  f-18-n ">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/Degree.png"
                />
                Doctorate of Nursing Practice (DNP) 2022
              </span>
            </div>

            <div className="p-3">
              <span className="d-flex flex-row  f-22-n text-primary">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/University.png"
                />
                UNIVERSITY OF KENTUCKY
              </span>
              <span className="d-flex my-1 flex-row  f-18-n ">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/Degree.png"
                />
                Psychiatry Mental Health Nurse Practitioner (PMHNP) 2018
              </span>
            </div>

            <div className="p-3">
              <span className="d-flex flex-row  f-22-n text-primary">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/University.png"
                />
                SPALDING UNIVERSITY
              </span>
              <span className="d-flex my-1 flex-row  f-18-n ">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/Degree.png"
                />
                Family Nurse Practitioner (FNP) 2013
              </span>
            </div>

            <div className="p-3">
              <span className="d-flex flex-row  f-22-n text-primary">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/University.png"
                />
                INDIANA WESLEYAN UNIVERSITY
              </span>
              <span className="d-flex my-1 flex-row  f-18-n ">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/Degree.png"
                />
                Bachelor’s Degree Nursing (BSN) 2008
              </span>
            </div>
            <div className="p-3">
              <span className="d-flex flex-row  f-22-n text-primary">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/University.png"
                />
                EASTERN KENTUCKY UNIVERSITY
              </span>
              <span className="d-flex my-1 flex-row  f-18-n ">
                <img
                  className="img-fluid px-3 university-icon"
                  src="/Images/Degree.png"
                />
                Associates in Nursing (ADN) 2004
              </span>
            </div>
          </div>

          <div
            data-aos="fade-right"
            className="col-md-6 col-12 order-1 order-md-1"
          >
            <img
              className="img-fluid shadow-plus-border h-75 w-100"
              src="Images/334.jpg"
              alt="picture"
            />
          </div>
        </div>

        {/* <hr className="container my-5 line" /> */}
        {/* <div className="d-flex justify-content-center align-items-center">
          <div className="col-md-4 d-lg-flex d-none" data-aos="fade-right">
            <img
              className="img-fluid about-us-team-img"
              src="/Images/OlgaSkinner.png"
              alt="profile image"
            />
          </div>
          <div className="col-md-8 col-12" data-aos="fade-left">
            <h3 className="text-primary">Olga Skinner</h3>
            <p className="f-22-b text-secondary">APRN</p>
            <p>
              Olga Skinner, APRN, is a distinguished Family Nurse Practitioner
              deeply committed to healthcare excellence, with an extensive
              background in medical provision and aesthetic medicine marked by
              unwavering dedication.
            </p>
            <div className="f-18-n custom-text-alignment">
              <p>
                Patients benefit from her integrated healthcare approach,
                blending medical expertise with compassion and multicultural
                sensitivity. Fluent in both English and Spanish, Olga has served
                diverse populations, including families, veterans, geriatric
                individuals, and underserved communities. She provides a range
                of services, including Family Primary Care, Acute and Post-Acute
                care, Palliative, and Hospice Services.
              </p>
              <p>
                Passionate about preventive care and overall wellness, Olga
                currently serves in Mount Sterling, delivering medical services
                to an underserved multicultural population. Beyond her medical
                practice, she enjoys aesthetic medicine and is the founder of OS
                Clinic Aesthetics, certified by the esteemed American Academy of
                Facial Esthetics (AAFE).
              </p>
              <p>
                Collaborating with Unicare, Olga's values align with the
                organization's emphasis on empowering new nurse practitioners
                and working collaboratively to address the medical, mental
                health, and addiction issues of underserved populations. This
                collaboration prioritizes the application of scientific
                evidence-based practices to ensure more effective outcomes.
              </p>
              <p>
                Olga's educational background includes a Bachelor of Science in
                Nursing from the University of Louisville and a Master of
                Science in Nursing with a specialization in Family Nurse
                Practice (FNP) from Spalding University in Louisville, Kentucky.
                Prior to nursing, she served in the USA Army and earned a BA in
                Business Administration from the Interamerican University of PR.
              </p>
            </div>
          </div>
        </div> */}

        {/* <hr className="container my-5 line" /> */}

        {/* <div className="d-flex justify-content-center align-items-center">
          <div className="col-md-4 d-lg-flex d-none" data-aos="fade-right">
            <img
              className="img-fluid about-us-team-img"
              src="/Images/Diana.jpeg"
              alt="profile image"
            />
          </div>

          <div className="col-md-8 col-12" data-aos="fade-left">
            <h3 className="text-primary">Diana Spring</h3>
            <p className="f-22-b text-secondary">
              APRN, FNP-C, Alcohol & Opioid Addiction
            </p>
            <div className="f-18-n custom-text-alignment">
              <p>
                I'm Dianna Spring, the owner of Healing Spring. I'm a nurse
                practitioner specializing in family medicine, psychiatry, opioid
                addiction, and hypnotherapy. I provide both in-person and
                telehealth consultations and am currently accepting new patients
                in Kentucky.
              </p>
              <p>
                My services include thorough psychiatric assessments, medication
                management, and supportive therapy for individuals dealing with
                conditions such as depression, anxiety, ADHD, bipolar disorder,
                personality disorders, stress intolerance, and addiction
                recovery. I approach treatment holistically, utilizing
                medication when necessary but primarily focusing on
                hypnotherapy.
              </p>
              <p>
                My aim is to help my patients heal, enhance their quality of
                life, and strengthen their relationships. I invite you to embark
                on a healing journey where I'll offer my unwavering support.
                Through secure video sessions, I can assist anyone located in
                Kentucky. New patients are encouraged to schedule their initial
                appointment at their convenience via Unicare psychiatry.
              </p>
            </div>
          </div>
        </div> */}

        {/* <hr className="container my-5 line" />
        <div className="d-flex justify-content-center align-items-center">
          <div className="col-md-4 d-lg-flex d-none" data-aos="fade-right">
            <img
              className="img-fluid about-us-team-img"
              src="/Images/Jason.jpeg"
              alt="profile image"
            />
          </div>
          <div className="col-md-8 col-12" data-aos="fade-left">
            <h3 className="text-primary">Jason Muzzillo</h3>
            <p className="f-22-b text-secondary">LCSW, Kentucky</p>
            <p className="f-18-b">
              Owner and founder of Resolution Therapy service - Kentucky
              (859-305-1430)
            </p>
            <div className="f-18-n custom-text-alignment">
              <p>
                My goal for my patients is to heal, improve quality of life, and
                improve relationships. I invite you to a journey of healing
                where I will support you. Through secure video, I can treat
                anyone located in Wisconsin and in IOWA. New patients are
                welcome to self-schedule their first appointment.
              </p>
              <p>
                Mindfulness Practices, along with my own experience in therapy,
                have left me with a passion that I enjoy sharing with others. My
                looking forward to working with Unicare Psychiatry who holds
                similar visions as Resolution Therapy Practice.
              </p>
            </div>
          </div>
        </div> */}

        {/* <hr className="container my-5 line" /> */}

        {/* <div className="d-flex justify-content-center align-items-center">
          <div className="col-md-4 d-lg-flex d-none" data-aos="fade-right">
            <img
              className="img-fluid about-us-team-img"
              src="/Images/Nikki.jpg"
              alt="profile image"
            />
          </div>
          <div className="col-md-8 col-12" data-aos="fade-left">
            <h3 className="text-primary">Nikki Myles</h3>
            <p className="f-22-b text-secondary">
              FNP-BC, PMHNP, Alcohol & Opioid Addiction
            </p>
            <p className="f-18-b">
              Owner and founder of Trilogy Behavioral Health Services, Wisonsin
            </p>
            <div className="f-18-n custom-text-alignment">
              <p>
                Hello ! My name is Nikki (Shalonda) Myles and excited to work
                with Unicare Psychiatry. I am a nurse practitioner (NP) also
                focus in family medicine and psychiatry. I offer in-person and
                Telehealth care.
              </p>
              <p>
                I provide comprehensive psychiatric evaluations, medication
                management, and supportive therapy for patients experiencing
                depression, anxiety, ADHD, bipolar disorder and personality
                disorders, stress intolerance and recovery from addiction. I
                practice a holistic approach to treatment, utilizing medication
                management as needed and a focus on lifestyle changes
              </p>
              <p>
                My goal for my patients is to heal, improve quality of life, and
                improve relationships. I invite you to a journey of healing
                where I will support you. Through secure video, I can treat
                anyone located in Wisconsin and in IOWA. New patients are
                welcome to self-schedule their first appointment.
              </p>
            </div>
          </div>
        </div> */}
        <div className="container mt-md-5 mt-3 line"></div>
        <div className="row text-center p-md-5 p-3">
          <div className="f-22-b text-primary">
            Discover the Unicare Difference
          </div>
          <div className="f-22-n text-secondary">
            "United we stand, divided we fall"
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OurTeamMembers;
